import { SpacesModel, SpacesModelImp } from './model/spaces-model';
import { ApiGetSpaces } from '@/infrastructure/api-functions/api-spaces';
import { SpaceApiServiceImpl } from '@/infrastructure/api-functions/space-api-service';
import { PaginatedSpacesRepositoryImpl } from './repository/paginated-spaces-repository';
import { PaginatedSpacesRepository } from './services/paginated-spaces-repository.interface';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import { CurrentSpaceService, SetCurrentSpaceService, GetCurrentSpaceService } from './services/current-space-service.interface';
import { CurrentSpaceServiceImpl } from './services/current-space-service';
import { SelectSpacesService } from './services/select-spaces-service.interface';
import { SelectSpacesServiceImpl } from './services/select-spaces-service';
import { SpaceActionContribution, SpaceActionRegistry } from '@/services/space-action-contribution';
import { SpaceActionRegistryImpl } from '@/services/space-action-registry';
import { SelectedSpaceIdsService } from '@/services/space-action-service';
import { WorkspaceHttpErrorHandler } from '@/infrastructure/error-handlers/workspace-http-error-handler';
import { ErrorHandlerContribution } from '@patsnap/tahiti-core/common/error-handler-contribution';
import { ApiEditSpace } from '@/infrastructure/api-functions/api-edit-space';
import { ApiUploadSpaceIcon } from '@/infrastructure/api-functions/api-upload-space-icon';
import { EditSpaceRepositoryImpl } from './repository/edit-space-repository';
import { EditSpaceServiceImpl } from './services/edit-space-service';
import { EditSpaceService, EditSpaceRepository } from './services/edit-space-service.interface';
import { SpaceFieldService } from './services/space-field-service.interface';
import { SpaceFieldServiceImpl } from './services/space-field-service';
import { SpaceViewTypeService } from './services/space-view-type-service.interface';
import { SpaceViewTypeServiceImpl } from './services/space-view-type-service';
import { SpaceSortTypeService } from './services/space-sort-type-service.interface';
import { SpaceSortTypeServiceImpl } from './services/space-sort-type-service';
import { PinSpaceService } from './services/pin-space-service.interface';
import { PinSpaceServiceImpl } from './services/pin-space-service';
import { PinSpaceRepository } from './repository/pin-space-repository.interface';
import { PinSpaceRepositoryImpl } from './repository/pin-space-repository';
import { SpacesApi } from './repository/apis/spaces-api.interface';
import { SpacesApiImpl } from './repository/apis/spaces-api';
import { SpaceCooperationRepository } from './repository/space-cooperation-repository.interface';
import { SpaceCooperationRepositoryImpl } from './repository/space-cooperation-repository';
import { SpaceCooperationServiceImpl } from './services/space-cooperation-service';
import { SpaceCooperationService } from './services/space-cooperation-service.interface';
import { ApiCreateSpace } from '@/infrastructure/api-functions/api-create-space';
import { CreateSpaceServiceImpl } from './services/create-space-service';
import { CreateSpaceRepository, CreateSpaceService } from './services/create-space-service.interface';
import { CreateSpaceRepositoryImpl } from './repository/create-space-repository';
import { InfiniteSpacesService } from './services/infinite-spaces-service.interface';
import { InfiniteSpacesServiceImpl } from './services/infinite-spaces-service';
import { SpaceQueryServiceImpl } from './services/space-query-service';
import { GetSpaceQueryService } from './services/space-query-service.interface';
import { SpaceLabelService } from './services/space-label-service.interface';
import { SpaceLabelServiceImpl } from './services/space-label-service';
import { UserAvatarModel } from './model/user-avatar-model.interface';
import { UserAvatarModelImpl } from './model/user-avatar-model';
import { UserAvatarRepository } from './repository/user-avatar-repository.interface';
import { UserAvatarRepositoryImpl } from './repository/user-avatar-repository';
import { UserAvatarService } from './services/user-avatar-service.interface';
import { UserAvatarServiceImpl } from './services/user-avatar-service';
export function spacesModule(bind) {
    bind(ErrorHandlerContribution).to(WorkspaceHttpErrorHandler);
    bindContributionProvider(bind, SpaceActionContribution);
    bind(SpaceActionRegistry).to(SpaceActionRegistryImpl);
    bind(SpacesModel).to(SpacesModelImp);
    bind(EditSpaceService).to(EditSpaceServiceImpl);
    bind(CreateSpaceService).to(CreateSpaceServiceImpl);
    bind(SelectSpacesService).to(SelectSpacesServiceImpl);
    bind(InfiniteSpacesService).to(InfiniteSpacesServiceImpl);
    bind(SelectedSpaceIdsService).toDynamicValue((context) => {
        const service = context.container.get(SelectSpacesService);
        return {
            getSelectedSpaceIds: () => service.getArraySelection(),
        };
    });
    function getCurrentSpaceService(context) {
        return context.container.get(CurrentSpaceService);
    }
    bind(GetSpaceQueryService).to(SpaceQueryServiceImpl);
    bind(CurrentSpaceService).to(CurrentSpaceServiceImpl);
    bind(SetCurrentSpaceService).toDynamicValue(getCurrentSpaceService);
    bind(GetCurrentSpaceService).toDynamicValue(getCurrentSpaceService);
    bind(CreateSpaceRepository).to(CreateSpaceRepositoryImpl);
    bind(EditSpaceRepository).to(EditSpaceRepositoryImpl);
    bind(PaginatedSpacesRepository).to(PaginatedSpacesRepositoryImpl);
    bind(ApiCreateSpace).to(SpaceApiServiceImpl);
    bind(ApiEditSpace).to(SpaceApiServiceImpl);
    bind(ApiUploadSpaceIcon).to(SpaceApiServiceImpl);
    bind(ApiGetSpaces).to(SpaceApiServiceImpl);
    bind(SpaceFieldService).to(SpaceFieldServiceImpl);
    bind(SpaceViewTypeService).to(SpaceViewTypeServiceImpl);
    bind(SpaceSortTypeService).to(SpaceSortTypeServiceImpl);
    bind(SpaceLabelService).to(SpaceLabelServiceImpl);
    bind(PinSpaceService).to(PinSpaceServiceImpl);
    bind(PinSpaceRepository).to(PinSpaceRepositoryImpl);
    bind(SpacesApi).to(SpacesApiImpl);
    bind(SpaceCooperationService).to(SpaceCooperationServiceImpl);
    bind(SpaceCooperationRepository).to(SpaceCooperationRepositoryImpl);
    bind(UserAvatarModel).to(UserAvatarModelImpl);
    bind(UserAvatarRepository).to(UserAvatarRepositoryImpl);
    bind(UserAvatarService).to(UserAvatarServiceImpl);
}
